export default "__VITE_ASSET__ByjpDSCB__"